import { JSX } from "react";

import {
  BillOfMaterialsDisplay,
  CommonErrorBoundary,
} from "@plansoft-configuration-renderer/components";
import { useConfigurationLanguage } from "@plansoft-configuration-renderer/framework";

import { useBom } from "./useBom";

export function BomContainer(): JSX.Element {
  const localeId = useConfigurationLanguage();

  const billOfMaterialsData = useBom();

  return (
    <CommonErrorBoundary>
      {billOfMaterialsData.data && (
        <BillOfMaterialsDisplay
          languageCode={localeId}
          data={billOfMaterialsData.data}
        />
      )}
    </CommonErrorBoundary>
  );
}
